module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Location Disabled","intro":"Uh-Oh! We are unable to continue because we do not have access to your location.","body":"No worries, you can enable your location permissions in your browser settings.","footer":"Or visit us at a store and we\u0027ll be happy to assist you.","appointmentButton":"Make an Appointment","tryAgainButton":"I Updated My Location Permissions"}}')
  delete Component.options._Ctor
}
